import { useEffect, useLayoutEffect, useReducer, useRef, useState } from "react"

export interface ElementSize {
  width: number
  height: number
}

// Measures an element's size via ResizeObserver and re-measures whenever it changes.
export const useElementSize = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  const [ size, setSize ] = useState<ElementSize>({ width: 0, height: 0 })
  const [ recalcTick, triggerRecalc ] = useReducer((c: number) => c + 1, 0)

  useEffect(() => {
    const el = ref.current
    if (!el) { return }
    const observer = new ResizeObserver(triggerRecalc)
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) { return }
    const { width, height } = el.getBoundingClientRect()
    setSize({ width, height })
  }, [recalcTick])

  return { ref, size }
}
